module.exports = __webpack_public_path__ + "img/D202009_2.b95d4ca7.jpg";